const getPostTaxAnnualContributions = user => {
  return user ? user.postTaxAnnualContributions : 0
}
const getPostTaxAnnualContribDollars = user => {
  return user ? user.postTaxAnnualContribDollars : 0
}

export { getPostTaxAnnualContributions, getPostTaxAnnualContribDollars }
